<div class="notifier-shell" [ngClass]="'notifier-' + status">
    <div class="notifier-header">
        <mat-icon class="notifier-icon" aria-hidden="true">{{statusIcons[status]}}</mat-icon>
        <div class="notifier-heading">
            <h2 *ngIf="data.message">{{data.message}}</h2>
        </div>
        <button *ngIf="data.list?.length" mat-icon-button class="details-button" (click)="showDetails()"
            [attr.aria-label]="showDetail ? 'Ocultar detalhes' : 'Mostrar detalhes'">
            <mat-icon>{{showDetail ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
    </div>

    <div *ngIf="showDetail" class="details">

            <div *ngIf="data.context === 'schedule'">
                <div *ngFor="let msg of data?.list">
                    {{msg.date}} {{msg.hour}}
                    <p> <b>{{msg.scheduleSource.date | date : 'dd/MM/yyyy'}} {{msg.scheduleSource.hour}}</b> para
                        <b>{{msg.scheduleTarget.date | date : 'dd/MM/yyyy'}}
                            {{msg.scheduleTarget.hour}}</b> {{msg.msg}}
                    </p>
                </div>
            </div>

            <div *ngIf="data.context === 'authorizerWS'">
                <div *ngFor="let msg of data?.list">
                    <p *ngIf="msg.code"> <b>Código: </b> {{msg.code}}</p>
                    <p *ngIf="msg.reason"> <b>Descrição: </b> {{msg.reason}}</p>
                    <p *ngIf="msg.reason2"> <b>Descrição: </b> {{msg.reason2}}</p>
                </div>
            </div>

            <div *ngIf="data.context === 'batchEntry'">
                <div *ngFor="let msg of data?.list">
                    <p *ngIf="msg.code"> <b>Paciente: </b> {{msg.code}}</p>
                    <p *ngIf="msg.reason"> <b>Descrição: </b> {{msg.reason}}</p>
                    <mat-divider></mat-divider>
                </div>
            </div>

            <div *ngIf="data.context === 'sendEmail'">
                <div *ngFor="let msg of data?.list">
                    <p *ngIf="msg.reason"> <b>Profissional: </b> {{msg.reason}}</p>
                    <p *ngIf="msg.code"> <b>Razão: </b> {{msg.code}}</p>
                    <mat-divider></mat-divider>
                </div>
            </div>

            <div *ngIf="data.context === 'simpleMessage'">
                <div *ngFor="let msg of data?.list">
                    <p class="textUpCaseFirst">{{msg}}</p>

                </div>
            </div>

            <div *ngIf="data.context === 'simpleDetail'">
                <div *ngFor="let msg of data?.list">
                    <p *ngIf="msg.reason"> <b>Descrição: </b> {{msg.reason}}</p>
                    <p *ngIf="msg.code"> <b>Código: </b> {{msg.code}}</p>
                    <mat-divider></mat-divider>
                </div>
            </div>


    </div>

    <div class="notifier-actions">
        <button mat-button class="dismiss-button" (click)="snackBarRef.dismiss()">Fechar</button>
    </div>
</div>